import VueAnalytics from 'vue-analytics'

export default ({ app, router, Vue }) => {
	let ids = []
	ids.push('UA-53707923-3')

	if (process.env.ID_GOOGLE_ANALYTICS != '') ids.push(process.env.ID_GOOGLE_ANALYTICS)
	if (process.env.ID_GOOGLE_ANALYTICS_CLIENT != '') ids.push(process.env.ID_GOOGLE_ANALYTICS_CLIENT)

	Vue.use(VueAnalytics, {
		id: ids,
		checkDuplicatedScript: true,
		router
	})
}
